import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import styles from './DevicesForm.module.scss';
import SelectVirtualized from '~/ui/components/inputs/SelectVirtualized';
import usePatientEnrollmentOptions from '~/ui/components/providers/PatientEnrollmentProvider/usePatientEnrollment';
import { DeviceType } from '~/services/api/enums';
import { IOption } from '~/ui/components/inputs/Select/types';
import PhoneInputsForm from '../PatientForm/PhoneInputsForm';
import { IPatientCreateFormValues } from '../../types';
import DocumentsForm from '../DocumentsForm';

const DevicesForm = () => {
  const { devices } = usePatientEnrollmentOptions();

  const {
    control,
    register,
    setValue,
    formState: { errors },
  } = useFormContext<IPatientCreateFormValues>();

  const deviceOptions = devices.reduce<Record<DeviceType, IOption[]>>(
    (acc, item) => {
      acc[item.typeId].push({
        value: item.id,
        label: item.name,
      });

      return acc;
    },
    {
      [DeviceType.BloodPressure]: [],
      [DeviceType.WeightScale]: [],
      [DeviceType.PulseOximeter]: [],
      [DeviceType.BloodGlucose]: [],
    },
  );

  const bloodPressureDeviceOptions = deviceOptions[DeviceType.BloodPressure];
  const weightScaleDeviceOptions = deviceOptions[DeviceType.WeightScale];
  const pulseOximeterDeviceOptions = deviceOptions[DeviceType.PulseOximeter];
  const bloodGlucoseDeviceOptions = deviceOptions[DeviceType.BloodGlucose];

  return (
    <div>
      <div className={styles.topTitle}>
        DEVICES
        <div className={styles.divider} />
      </div>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <SelectVirtualized
            name="bloodPressureDeviceId"
            control={control}
            errors={errors}
            options={bloodPressureDeviceOptions}
            label="Blood Pressure"
            placeholder="Not Selected"
          />
        </Grid>
        <Grid item xs={4}>
          <SelectVirtualized
            name="weightScaleDeviceId"
            control={control}
            errors={errors}
            options={weightScaleDeviceOptions}
            label="Weight Scale"
            placeholder="Not Selected"
          />
        </Grid>
        <Grid item xs={4}>
          <SelectVirtualized
            name="pulseOximeterDeviceId"
            control={control}
            errors={errors}
            options={pulseOximeterDeviceOptions}
            label="Pulse Oximeter"
            placeholder="Not Selected"
          />
        </Grid>
        <Grid item xs={4}>
          <SelectVirtualized
            name="bloodGlucoseDeviceId"
            control={control}
            errors={errors}
            options={bloodGlucoseDeviceOptions}
            label="Blood Glucose"
            placeholder="Not Selected"
          />
        </Grid>
      </Grid>

      <div className={styles.title}>
        CARETAKER
        <div className={styles.divider} />
      </div>

      <PhoneInputsForm
        control={control}
        name="caretakers"
        errors={errors}
        register={register}
        setValue={setValue}
      />

      <div className={styles.title}>
        Documentation
        <div className={styles.divider} />
      </div>

      <DocumentsForm />
    </div>
  );
};

export default DevicesForm;
